module.exports = __webpack_public_path__ + "img/70.2dc854f6.jpg";